module.exports = __webpack_public_path__ + "media/img/vca/bg-sponsor-f21236eeae6d746a27a87bb6fef9695d.png";